/**
 * Created by lu on 2017/9/11.
 */
var nb = require('../nb');
module.exports = nb.define({
    view: {
        $html: [{
            'class': 'footer-box',
            $html: {
                'class': 'footer-content clearfix',
                $html: [{
                    'class': 'footer-logo',
                    $html: {
                        tag: 'img',
                        src: './image/logo/logo.png'
                    }
                }, {
                    'class': 'footer-list-box',
                    $html: [{
                        'class': 'footer-list',
                        $html: {
                            'class': 'footer-item',
                            $html: [{
                                'class': 'title footer-label',
                                $text: nb.bind('title1')
                            }, {
                                'class': 'list',
                                $html: [
                                    {
                                        'class': 'item-link',
                                        tag: 'a',
                                        href: nb.bind('link1_1_url'),
                                        target: '_blank',
                                        $text: nb.bind('link1_1')
                                    },
                                    {
                                        'class': 'item-link',
                                        tag: 'a',
                                        href: nb.bind('link1_2_url'),
                                        target: '_blank',
                                        $text: nb.bind('link1_2')
                                    },
                                    {
                                        'class': 'item-link',
                                        tag: 'a',
                                        href: nb.bind('link1_3_url'),
                                        target: '_blank',
                                        $text: nb.bind('link1_3')
                                    },
                                    {
                                        'class': 'item-link',
                                        tag: 'a',
                                        href: nb.bind('link1_4_url'),
                                        target: '_blank',
                                        $text: nb.bind('link1_4')
                                    },

                                    // {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: nb.bind('companyProfileUrl'),
                                    //     target: '_blank',
                                    //     $text: nb.bind('companyProfile')
                                    //     // $text: '公司简介'
                                    // },
                                    // {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: nb.bind('socialResponsibilityUrl'),
                                    //     target: '_blank',
                                    //     $text: nb.bind('socialResponsibility')
                                    //     // $text: '社会责任'
                                    // },
                                    // {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: nb.bind('careerDevelopmentUrl'),
                                    //     target: '_blank',
                                    //     $text: nb.bind('careerDevelopment')
                                    //     // $text: '职业发展'
                                    // }
                                    // , {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: '#',
                                    //     target: '_blank',
                                    //     $text: nb.bind('termsConditions')
                                    //     // $text: '细则及条款'
                                    // }
                                ]
                            }]
                        }
                    }, {
                        'class': 'footer-list',
                        $html: {
                            'class': 'footer-item',
                            $html: [{
                                'class': 'title footer-label',
                                $text: nb.bind('title2')
                                // $text: '购物帮助'
                            }, {
                                'class': 'list',
                                $html: [
                                    {
                                        'class': 'item-link',
                                        tag: 'a',
                                        href: nb.bind('link2_1_url'),
                                        target: '_blank',
                                        $text: nb.bind('link2_1')
                                    },
                                    {
                                        'class': 'item-link',
                                        tag: 'a',
                                        href: nb.bind('link2_2_url'),
                                        target: '_blank',
                                        $text: nb.bind('link2_2')
                                    },
                                    {
                                        'class': 'item-link',
                                        tag: 'a',
                                        href: nb.bind('link2_3_url'),
                                        target: '_blank',
                                        $text: nb.bind('link2_3')
                                    },
                                    {
                                        'class': 'item-link',
                                        tag: 'a',
                                        href: nb.bind('link2_4_url'),
                                        target: '_blank',
                                        $text: nb.bind('link2_4')
                                    },
                                    // {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: '#',
                                    //     target: '_blank',
                                    //     $text: nb.bind('payRelated')
                                    //     // $text: '支付相关'
                                    // },
                                    // {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: '#',
                                    //     target: '_blank',
                                    //     $text: nb.bind('modeDistribution')//mode of distribution
                                    //     // $text: '配送方式'
                                    // },
                                    // {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: '#',
                                    //     target: '_blank',
                                    //     $text: nb.bind('returnWay')
                                    //     // $text: '退货方式'
                                    // },
                                    // {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: '#',
                                    //     target: '_blank',
                                    //     $text: nb.bind('invoiceRelevant')
                                    //     // $text: '发票相关'
                                    // }
                                ]
                            }]
                        }
                    }, {
                        'class': 'footer-list',
                        $html: {
                            'class': 'footer-item',
                            $html: [{
                                'class': 'title footer-label',
                                $text: nb.bind('title3')
                                // $text: '需要帮助'
                            }, {
                                'class': 'list',
                                $html: [
                                    {
                                        'class': 'item-link',
                                        tag: 'a',
                                        href: nb.bind('link3_1_url'),
                                        target: '_blank',
                                        $text: nb.bind('link3_1')
                                    },
                                    {
                                        'class': 'item-link',
                                        tag: 'a',
                                        href: nb.bind('link3_2_url'),
                                        target: '_blank',
                                        $text: nb.bind('link3_2')
                                    },

                                    // {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: nb.bind('contactUsUrl'),
                                    //     target: '_blank',
                                    //     $text: nb.bind('contactUs')
                                    //     // $text: '联系我们'
                                    // },
                                    // {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: '#',
                                    //     target: '_blank',
                                    //     $text: nb.bind('commonProblems')
                                    //     // $text: '常见问题'
                                    // },
                                    // {
                                    //     'class': 'item-link',
                                    //     tag: 'a',
                                    //     href: '#',
                                    //     target: '_blank',
                                    //     $text: nb.bind('shoppingGuide')
                                    //     // $text: '购物指南'
                                    // }
                                ]
                            }]
                        }
                    }, {
                        'class': 'footer-list',
                        $html: {
                            'class': 'footer-item',
                            $html: [{
                                'class': 'title footer-label',
                                $text: nb.bind('followUs')
                                // $text: '关注我们'
                            }, {
                                'class': 'list',
                                $html: [{
                                    'class': 'item-link weChat',
                                    $html: [{
                                        'class': 'icon',
                                        tag: 'img',
                                        src: './image/mockup/footer/wechat.png'
                                    }, {
                                        'class': 'text',
                                        tag: 'span',
                                        $text: nb.bind('weChat')
                                        // $text: '微信'
                                    }, {
                                        'class': 'weChat-icon',
                                        tag: 'img',
                                        src: ''
                                    }]
                                }, {
                                    'class': 'item-link weibo',
                                    $html: [{
                                        tag: 'a',
                                        target: '_blank',
                                        href: '#',
                                        $html: [{
                                            'class': 'icon',
                                            tag: 'img',
                                            src: './image/mockup/footer/weibo.png'
                                        }, {
                                            'class': 'text',
                                            tag: 'span',
                                            $text: nb.bind('sinaMicroblog')
                                            // $text: '新浪微博'
                                        }]
                                    }]
                                }, {
                                    'class': 'item-link tell',
                                    $html: [{
                                        'class': 'icon',
                                        tag: 'img',
                                        src: './image/mockup/footer/phone.png'
                                    }, {
                                        'class': 'text',
                                        tag: 'span',
                                        $text: '400-883-2299'
                                    }]
                                }]
                            }]
                        }
                    }]
                }]
            }
        }, {
            'class': 'footer-record',
            $text: 'ASC-WINES © 2018. All Rights Reserved. 沪ICP备05040324号-1'
        }]
    },
    method: {
        init: function () {
            nb.model.onChange(nb.opts.clientReady, function () {

            }, this);
        }
    }
});





//////////////////
// WEBPACK FOOTER
// ../src/js/view/Footer.js
// module id = 62
// module chunks = 5 6 17 24 31 33 37 38